import React from "react";
import styled from "styled-components";

const StyledParkAndRideIcon = styled.div`
  background: #000;
  border-radius: 17px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  height: 12px;
  line-height: 0px;
  padding-left: 7px;
  padding-top: 12px;
  width: 17px;
`;

const ParkAndRideMarker = (): JSX.Element => (
  <StyledParkAndRideIcon>P</StyledParkAndRideIcon>
);

export default ParkAndRideMarker;
